var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.557,
    viewBox: "0 0 24 24.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.683)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.683)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.77 14.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.957,151.8h.508a.186.186,0,0,1,.053-.114l.945-.945a.846.846,0,0,1-.119-.43v-.4a2.44,2.44,0,0,1-2.266,0v.4a.847.847,0,0,1-.118.431l.944.944A.187.187,0,0,1,115.957,151.8Z",
    transform: "translate(-114.96 -149.914)",
    fill: "#f9d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.364 8.506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9,88.9a2.391,2.391,0,0,0-2.149.054v3.461a2.391,2.391,0,0,1,2.023-.109c.114.046.233-.052.233-.2V89.094A.212.212,0,0,0,39.9,88.9Z",
    transform: "translate(-37.747 -88.672)",
    fill: "#edf4fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.107 8.506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.333,88.9a.211.211,0,0,0-.107.194V92.11c0,.145.119.243.233.2a2.391,2.391,0,0,1,2.023.109V88.955A2.391,2.391,0,0,0,14.333,88.9Z",
    transform: "translate(-14.226 -88.672)",
    fill: "#edf4fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.24 9.096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.234,94.826h-.671v2.848c0,.145-.119.243-.233.2a2.391,2.391,0,0,0-2.023.109,2.391,2.391,0,0,0-2.023-.109c-.114.046-.233-.052-.233-.2V94.826H5.379a.2.2,0,0,0-.2.2v3.584a.2.2,0,0,0,.2.2h5.855a.2.2,0,0,0,.2-.2V95.022A.2.2,0,0,0,11.234,94.826Z",
    transform: "translate(-5.183 -94.826)",
    fill: "#e4efff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.155 1.679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2,17.753a.288.288,0,0,0-.286-.253H46.3a.288.288,0,0,0-.286.253,2.2,2.2,0,0,0-.017.275,2.111,2.111,0,1,0,4.221,0A2.223,2.223,0,0,0,50.2,17.753Z",
    transform: "translate(-46 -17.5)",
    fill: "#edf4fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.491 4.365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.834,45.5H49.715a.215.215,0,0,0-.215.215.744.744,0,0,0,.744.744h2.061a.744.744,0,0,0,.744-.744A.215.215,0,0,0,52.834,45.5Z",
    transform: "translate(-49.5 -45.5)",
    fill: "#edf4fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.682 2.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.633,24.326a.153.153,0,0,1,.038.153l.632.673a.152.152,0,0,0,.043-.029l.707-.707-.8-.8-.665.665Z",
    transform: "translate(-176.591 -23.619)",
    fill: "#edf4fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.22 2.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.148,23.618l.707.707a.154.154,0,0,1,0,.218l-.579.579a.154.154,0,0,1-.218,0l-.707-.707Z",
    transform: "translate(-161.351 -23.618)",
    fill: "#edf4fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.579 3.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.167,39.612a.153.153,0,0,1-.111-.008l-1.284,1.367a.394.394,0,0,0,.558.558l1.439-1.351Z",
    transform: "translate(-154.665 -39.604)",
    fill: "#d1956d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.08 3.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.384,33.231l.579-.579a.152.152,0,0,0,.038-.064l1.917,2.041a.394.394,0,0,1-.558.558l-2.041-1.917A.153.153,0,0,0,170.384,33.231Z",
    transform: "translate(-170.319 -32.587)",
    fill: "#d1956d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.347 0.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.322,11.166l-.8-.8A1.725,1.725,0,0,1,184,9.253c.391-.391,1.05-.089,1.494-.272a.228.228,0,0,1,.319.189A1.62,1.62,0,0,1,184.322,11.166Z",
    transform: "translate(-183.525 -8.963)",
    fill: "#f5c84c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.715 0.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.169,11.166l.8-.8a1.725,1.725,0,0,0-.478-1.116c-.391-.391-1.05-.089-1.494-.272a.228.228,0,0,0-.319.189A1.62,1.62,0,0,0,147.169,11.166Z",
    transform: "translate(-145.664 -8.963)",
    fill: "#f5c84c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.266 8.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.4,88.422l-2.867.614V87.91L206.4,87.3Z",
    transform: "translate(-203.529 -87.296)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.699 11.343)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.717,
    cy: 0.717,
    r: 0.717,
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.833 11.957)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.717,
    cy: 0.717,
    r: 0.717,
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.67 17.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.531,187.853l-.273-.879c-.006-.019-.013-.037-.02-.055a.607.607,0,0,0-.96-.2l-.121.107a.329.329,0,0,1-.524-.127.291.291,0,0,0-.4-.215.571.571,0,0,0-.338.581l.045.433a.572.572,0,0,1-.323.584c-.283.134-.826.388-1.915.91a.122.122,0,0,1-.153-.04l-.449-.645-1.627,1.24,1.014,1.394a.931.931,0,0,0,1.26.232l2.751-1.79a4.342,4.342,0,0,1,.747-.389l.924-.372A.629.629,0,0,0,183.531,187.853Z",
    transform: "translate(-176.469 -186.459)",
    fill: "#f9d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.281 17.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.644,187.853l.273-.879c.006-.019.013-.037.02-.055a.607.607,0,0,1,.96-.2l.121.107a.329.329,0,0,0,.524-.127.291.291,0,0,1,.4-.215.571.571,0,0,1,.338.581l-.045.433a.572.572,0,0,0,.323.584c.283.134.826.388,1.915.91a.122.122,0,0,0,.153-.04l.449-.645,1.627,1.24-1.014,1.394a.931.931,0,0,1-1.26.232l-2.751-1.79a4.342,4.342,0,0,0-.747-.389l-.924-.372a.629.629,0,0,1-.366-.77Z",
    transform: "translate(-5.616 -186.459)",
    fill: "#f9d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.596 15.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.825,168.192l-1.445-2.212a2.519,2.519,0,0,0-1.419-.957,11.121,11.121,0,0,1-1.465-.418.186.186,0,0,1-.048.084l-.99.99a.188.188,0,0,1-.265,0l-.443-.443a.187.187,0,0,1-.053-.151h-.508a.186.186,0,0,1-.053.151l-.443.443a.188.188,0,0,1-.265,0l-.99-.99a.186.186,0,0,1-.048-.084,11.114,11.114,0,0,1-1.465.418,2.519,2.519,0,0,0-1.419.957l-1.445,2.212a.226.226,0,0,0,.045.312l1.729,1.317a.226.226,0,0,0,.315-.041l.952-1.261v4.374a.238.238,0,0,0,.238.238h6.2a.238.238,0,0,0,.238-.238V168.52l.952,1.261a.226.226,0,0,0,.315.041L73.78,168.5A.226.226,0,0,0,73.825,168.192Z",
    transform: "translate(-61.018 -164.605)",
    fill: "#285caa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.461 17.646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.265,189.306a1.169,1.169,0,0,1-.947-.482l-.984-1.351a.24.24,0,1,1,.388-.282l.984,1.352a.69.69,0,0,0,.935.172l2.751-1.79a4.583,4.583,0,0,1,.789-.41l.924-.372a.391.391,0,0,0,.226-.476l-.273-.879c0-.011-.008-.023-.013-.035a.332.332,0,0,0-.238-.2.385.385,0,0,0-.342.085l-.121.107a.569.569,0,0,1-.906-.22.242.242,0,0,1-.013-.045.051.051,0,0,0-.071-.038.33.33,0,0,0-.2.337l.045.433a.81.81,0,0,1-.459.826l-.213.1c-.319.151-.839.4-1.7.809a.36.36,0,0,1-.453-.119l-.416-.6a.24.24,0,1,1,.394-.274l.358.515c.81-.388,1.305-.621,1.614-.767l.212-.1a.332.332,0,0,0,.188-.339l-.045-.436a.808.808,0,0,1,.48-.826.531.531,0,0,1,.729.36.088.088,0,0,0,.056.042.087.087,0,0,0,.08-.02l.121-.107a.866.866,0,0,1,.768-.193.809.809,0,0,1,.573.48q.015.037.027.075l.273.879a.873.873,0,0,1-.505,1.063l-.924.372a4.1,4.1,0,0,0-.706.367l-2.751,1.79A1.169,1.169,0,0,1,176.265,189.306Z",
    transform: "translate(-174.288 -183.961)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.042 17.646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.684,189.3a1.166,1.166,0,0,1-.638-.19L5.3,187.322a4.1,4.1,0,0,0-.706-.367l-.924-.372a.873.873,0,0,1-.505-1.063l.273-.879c.008-.026.017-.051.027-.076a.809.809,0,0,1,.573-.481.867.867,0,0,1,.767.193l.122.107a.089.089,0,0,0,.136-.022.531.531,0,0,1,.73-.36.808.808,0,0,1,.48.826l-.045.433a.333.333,0,0,0,.187.343l.212.1c.309.146.8.379,1.614.767l.365-.524a.24.24,0,0,1,.394.274l-.422.607a.36.36,0,0,1-.453.119c-.862-.413-1.382-.658-1.7-.809l-.213-.1a.812.812,0,0,1-.459-.829l.045-.43a.33.33,0,0,0-.2-.337.051.051,0,0,0-.071.038.236.236,0,0,1-.013.045.569.569,0,0,1-.905.22l-.122-.107a.385.385,0,0,0-.342-.085.332.332,0,0,0-.238.2c0,.011-.009.023-.013.035l-.273.878a.391.391,0,0,0,.226.476l.924.372a4.587,4.587,0,0,1,.789.41l2.751,1.79a.69.69,0,0,0,.935-.172l.981-1.347a.24.24,0,0,1,.388.282l-.981,1.347A1.169,1.169,0,0,1,8.684,189.3Z",
    transform: "translate(-3.122 -183.957)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.357 15.565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.293,171.257h-6.2a.478.478,0,0,1-.478-.478V167.12l-.521.69a.467.467,0,0,1-.652.088l-1.729-1.317a.468.468,0,0,1-.1-.639l1.442-2.208.007-.01a2.759,2.759,0,0,1,1.554-1.048c.192-.052.36-.092.512-.129a5.993,5.993,0,0,0,.881-.263.24.24,0,0,1,.178.446,6.436,6.436,0,0,1-.946.283c-.149.036-.313.076-.5.128a2.278,2.278,0,0,0-1.284.862l-1.44,2.206,1.707,1.3.942-1.248a.24.24,0,0,1,.431.145v4.374l6.2,0,0-4.373a.24.24,0,0,1,.431-.145l.942,1.248,1.707-1.3L69.931,164a2.28,2.28,0,0,0-1.281-.861c-.194-.052-.358-.092-.506-.128a6.425,6.425,0,0,1-.95-.285.24.24,0,0,1,.178-.445,6,6,0,0,0,.885.264c.152.037.319.078.514.13a2.76,2.76,0,0,1,1.551,1.047l.007.01,1.442,2.208a.468.468,0,0,1-.1.639L69.943,167.9a.466.466,0,0,1-.65-.086l-.523-.692v3.659A.479.479,0,0,1,68.293,171.257Z",
    transform: "translate(-58.527 -162.266)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.961 15.111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.273,158.572l-.99-.99a.188.188,0,0,0-.265,0l-.443.443a.188.188,0,0,0,0,.265l.99.99a.188.188,0,0,0,.265,0l.443-.443A.188.188,0,0,0,108.273,158.572Z",
    transform: "translate(-106.52 -157.527)",
    fill: "#9be5f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.273 15.111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.686,158.572l.99-.99a.188.188,0,0,1,.265,0l.443.443a.188.188,0,0,1,0,.265l-.99.99a.188.188,0,0,1-.265,0l-.443-.443A.188.188,0,0,1,130.686,158.572Z",
    transform: "translate(-130.631 -157.527)",
    fill: "#9be5f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.721 14.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.439,157.315a.426.426,0,0,1-.3-.125l-.99-.99a.428.428,0,0,1,0-.6l.443-.443a.428.428,0,0,1,.6,0l.99.99h0a.428.428,0,0,1,0,.6l-.443.443A.426.426,0,0,1,105.439,157.315Zm-.916-1.417.916.916.369-.369-.916-.916Z",
    transform: "translate(-104.021 -155.027)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.034 14.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129,157.315a.425.425,0,0,1-.3-.125l-.443-.443a.428.428,0,0,1,0-.6h0l.99-.99a.428.428,0,0,1,.6,0l.443.443a.428.428,0,0,1,0,.6l-.99.99A.426.426,0,0,1,129,157.315Zm-.369-.87.369.369.916-.916-.369-.369Z",
    transform: "translate(-128.135 -155.027)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.562 9.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.189,95.6a2.666,2.666,0,0,1-2.669.877.131.131,0,0,0-.159.127v1.98a2.459,2.459,0,0,0,4.919,0V96.4c0-.013,0-.026,0-.038a.132.132,0,0,0-.127-.129,2.561,2.561,0,0,1-1.767-.638.132.132,0,0,0-.2.012Z",
    transform: "translate(-102.361 -95.554)",
    fill: "#f9d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.763 6.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.679,75.122a1.03,1.03,0,0,1,.158.012v-.118A.131.131,0,0,1,95,74.889a2.666,2.666,0,0,0,2.669-.877.132.132,0,0,1,.2-.012,2.56,2.56,0,0,0,1.767.638.132.132,0,0,1,.127.129c0,.013,0,.026,0,.038v.329a1.021,1.021,0,0,1,.87.276V73.563a1.409,1.409,0,0,0-1.4-1.4,1.391,1.391,0,0,0-.718.2,1.406,1.406,0,0,0-1.2-.688h-.721a2.546,2.546,0,0,0-2.539,2.539v1.137a1.021,1.021,0,0,1,.64-.225Z",
    transform: "translate(-94.039 -71.671)",
    fill: "#754e34"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.474 10.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.738,107.646a1.03,1.03,0,0,0-.158.012v1.862c0,.055,0,.11-.006.165a1.026,1.026,0,1,0,.164-2.039Z",
    transform: "translate(-153.574 -107.646)",
    fill: "#f9d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.377 10.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2,109.52v-1.862a1.027,1.027,0,1,0,.006,2.027C91.2,109.631,91.2,109.576,91.2,109.52Z",
    transform: "translate(-90.012 -107.646)",
    fill: "#f9d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.322 8.926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.56,99.027a2.7,2.7,0,0,1-2.7-2.7V94.349a.371.371,0,0,1,.448-.363,2.41,2.41,0,0,0,2.432-.791.372.372,0,0,1,.552-.034,2.337,2.337,0,0,0,1.606.569.371.371,0,0,1,.36.364c0,.014,0,.029,0,.043v2.191a2.7,2.7,0,0,1-2.7,2.7Zm-2.22-4.547v1.848a2.22,2.22,0,1,0,4.439,0V94.2a2.823,2.823,0,0,1-1.737-.623A2.9,2.9,0,0,1,100.341,94.48Zm2.776-.987Zm-.188-.149h0Z",
    transform: "translate(-99.861 -93.054)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.523 6.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.363,73.332a.24.24,0,0,1-.24-.24V71.3a1.161,1.161,0,0,0-1.759-1,.24.24,0,0,1-.329-.082,1.173,1.173,0,0,0-1-.571h-.721a2.3,2.3,0,0,0-2.3,2.3v1.1a.24.24,0,0,1-.48,0v-1.1a2.782,2.782,0,0,1,2.778-2.778h.721a1.653,1.653,0,0,1,1.282.619,1.628,1.628,0,0,1,.641-.132A1.647,1.647,0,0,1,98.6,71.3v1.791A.24.24,0,0,1,98.363,73.332Z",
    transform: "translate(-91.536 -69.17)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.309 10.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.177,107.679c-.038,0-.076,0-.113-.006a.24.24,0,1,1,.047-.477c.022,0,.044,0,.066,0a.787.787,0,0,0,0-1.574l-.06,0a.24.24,0,0,1-.039-.478c.033,0,.066,0,.1,0a1.267,1.267,0,0,1,0,2.533Z",
    transform: "translate(-151.847 -105.146)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.137 10.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.779,107.679a1.267,1.267,0,0,1,0-2.533c.033,0,.067,0,.1,0a.24.24,0,1,1-.039.478l-.06,0a.787.787,0,0,0,0,1.574l.061,0a.24.24,0,1,1,.044.478C88.849,107.677,88.814,107.679,88.779,107.679Z",
    transform: "translate(-87.512 -105.146)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.914 14.191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.651,149.163a.24.24,0,0,1-.212-.128,1.088,1.088,0,0,1-.127-.508v-.35a.24.24,0,1,1,.48,0v.35a.608.608,0,0,0,.071.283.24.24,0,0,1-.212.352Z",
    transform: "translate(-137.312 -147.938)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.571 16.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.976,167.588h-.424a.24.24,0,1,1,0-.48h.424a.24.24,0,1,1,0,.48Z",
    transform: "translate(-123.312 -167.108)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.562 14.185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.033,149.082a.24.24,0,0,1-.215-.345.6.6,0,0,0,.062-.266v-.356a.24.24,0,0,1,.48,0v.356a1.093,1.093,0,0,1-.11.477A.24.24,0,0,1,113.033,149.082Z",
    transform: "translate(-112.793 -147.875)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.124 8.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.487,93.8a.24.24,0,0,1-.24-.24V90.3a.24.24,0,0,1,.48,0v3.259A.24.24,0,0,1,35.487,93.8Z",
    transform: "translate(-35.247 -90.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.867 8.267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.221,90.409a.24.24,0,0,1-.113-.028,2.146,2.146,0,0,0-1.82-.1.39.39,0,0,1-.369-.039.454.454,0,0,1-.194-.38V86.848a.449.449,0,0,1,.245-.411,2.644,2.644,0,0,1,2.251,0,2.644,2.644,0,0,1,2.251,0,.449.449,0,0,1,.245.411v3.015a.455.455,0,0,1-.194.38.39.39,0,0,1-.369.039,2.146,2.146,0,0,0-1.821.1A.239.239,0,0,1,14.221,90.409Zm-1.128-.763a2.627,2.627,0,0,1,1.128.255,2.625,2.625,0,0,1,2.016-.1V86.857a2.162,2.162,0,0,0-1.9.062.239.239,0,0,1-.226,0,2.161,2.161,0,0,0-1.9-.063V89.8A2.625,2.625,0,0,1,13.093,89.646Zm3.174-2.775h0Z",
    transform: "translate(-11.725 -86.186)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.974,96.781H3.119a.436.436,0,0,1-.436-.436V92.761a.436.436,0,0,1,.436-.436H3.73a.24.24,0,0,1,0,.48H3.163v3.5H8.93V92.8H8.4a.24.24,0,0,1,0-.48h.577a.436.436,0,0,1,.436.436v3.584A.436.436,0,0,1,8.974,96.781Z",
    transform: "translate(-2.683 -92.325)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.917 9.184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.752,96.243a.24.24,0,0,1-.032-.478,2.588,2.588,0,0,1,.682,0,.24.24,0,0,1-.063.476,2.111,2.111,0,0,0-.556,0Z",
    transform: "translate(-43.512 -95.743)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.917 10.004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.752,104.794a.24.24,0,0,1-.032-.478,2.588,2.588,0,0,1,.682,0,.24.24,0,1,1-.063.476,2.107,2.107,0,0,0-.556,0Z",
    transform: "translate(-43.512 -104.294)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.917 10.825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.752,113.345a.24.24,0,0,1-.032-.478,2.588,2.588,0,0,1,.682,0,.24.24,0,0,1-.063.476,2.115,2.115,0,0,0-.556,0Z",
    transform: "translate(-43.512 -112.845)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.661 9.184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.857,96.244l-.032,0a2.1,2.1,0,0,0-.556,0,.24.24,0,1,1-.063-.475,2.58,2.58,0,0,1,.682,0,.24.24,0,0,1-.032.477Z",
    transform: "translate(-19.997 -95.743)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.661 10.004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.857,104.795l-.032,0a2.107,2.107,0,0,0-.556,0,.24.24,0,0,1-.063-.476,2.58,2.58,0,0,1,.682,0,.24.24,0,0,1-.032.477Z",
    transform: "translate(-19.997 -104.294)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.661 10.825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.857,113.346l-.032,0a2.107,2.107,0,0,0-.556,0,.24.24,0,0,1-.063-.476,2.58,2.58,0,0,1,.682,0,.24.24,0,0,1-.032.477Z",
    transform: "translate(-19.997 -112.845)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.915 1.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.85,18.166a2.377,2.377,0,0,1-2.35-2.4,2.445,2.445,0,0,1,.019-.305A.529.529,0,0,1,44.043,15h3.614a.529.529,0,0,1,.524.462,2.444,2.444,0,0,1,.019.305A2.377,2.377,0,0,1,45.85,18.166ZM44.043,15.48a.049.049,0,0,0-.048.042,1.99,1.99,0,0,0-.015.245,1.871,1.871,0,1,0,3.741,0,1.981,1.981,0,0,0-.015-.245h0a.049.049,0,0,0-.048-.042Z",
    transform: "translate(-43.5 -15)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.251 4.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.045,44.439H47.984A.985.985,0,0,1,47,43.455.455.455,0,0,1,47.455,43h3.119a.455.455,0,0,1,.455.455A.985.985,0,0,1,50.045,44.439ZM47.48,43.48a.505.505,0,0,0,.5.48h2.061a.505.505,0,0,0,.5-.48Zm3.094,0h0Z",
    transform: "translate(-47 -43)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.74.959a.24.24,0,0,1-.24-.24V.24a.24.24,0,1,1,.48,0v.48A.24.24,0,0,1,55.74.959Z",
    transform: "translate(-55.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.74.959a.24.24,0,0,1-.24-.24V.24a.24.24,0,0,1,.48,0v.48A.24.24,0,0,1,65.74.959Z",
    transform: "translate(-65.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.74.959a.24.24,0,0,1-.24-.24V.24a.24.24,0,0,1,.48,0v.48A.24.24,0,0,1,75.74.959Z",
    transform: "translate(-75.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.584 1.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.641,21.11H81.99a.24.24,0,1,1,0-.48h.651a.909.909,0,0,0,.856-.606.409.409,0,0,0-.386-.546h-.545a.24.24,0,1,1,0-.48h.545a.889.889,0,0,1,.838,1.185A1.389,1.389,0,0,1,82.641,21.11Z",
    transform: "translate(-81.75 -19)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.026 8.134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.269,87.017a.24.24,0,0,1-.24-.24V85.651a.24.24,0,0,1,.19-.234l2.867-.614a.24.24,0,0,1,.29.234v1.126a.24.24,0,0,1-.19.234l-2.867.614A.234.234,0,0,1,201.269,87.017Zm.24-1.172v.636l2.387-.511v-.636Zm2.627.318h0Z",
    transform: "translate(-201.029 -84.797)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.893 9.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.152,99.575a.24.24,0,0,1-.24-.24V96.776a.24.24,0,1,1,.48,0v2.559A.24.24,0,0,1,231.152,99.575Z",
    transform: "translate(-230.912 -96.536)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.46 11.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.926,117.658a.957.957,0,1,1,.956-.956A.958.958,0,0,1,216.926,117.658Zm0-1.433a.477.477,0,1,0,.477.477A.477.477,0,0,0,216.926,116.225Z",
    transform: "translate(-215.97 -115.745)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.026 9.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.269,105.978a.24.24,0,0,1-.24-.24v-2.559a.24.24,0,1,1,.48,0v2.559A.24.24,0,0,1,201.269,105.978Z",
    transform: "translate(-201.029 -102.939)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.593 11.717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.044,124.063a.956.956,0,1,1,.956-.956A.958.958,0,0,1,187.044,124.063Zm0-1.433a.477.477,0,1,0,.477.477A.477.477,0,0,0,187.044,122.63Z",
    transform: "translate(-186.088 -122.15)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.485 2.054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.712 0.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.2,30.9a.24.24,0,0,1-.17-.409l.677-.677a.24.24,0,1,1,.339.339l-.677.677A.239.239,0,0,1,182.2,30.9Z",
    transform: "translate(-181.96 -29.743)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.779,22.488a.24.24,0,0,1-.17-.409l.594-.594a.24.24,0,0,1,.339.339l-.594.594A.239.239,0,0,1,174.779,22.488Z",
    transform: "translate(-174.539 -21.415)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.107 0.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.061,9.146a.24.24,0,0,1-.17-.07l-.8-.8a.24.24,0,0,1-.07-.17,1.964,1.964,0,0,1,.548-1.285,1.319,1.319,0,0,1,1.048-.28,1.38,1.38,0,0,0,.525-.043.478.478,0,0,1,.434.035.455.455,0,0,1,.216.36c.087,1.357-.487,2.113-1.707,2.249l-.026,0Zm-.55-1.129.636.636c1.111-.174,1.214-1,1.171-1.708a1.694,1.694,0,0,1-.712.078c-.287-.009-.536-.017-.693.14A1.467,1.467,0,0,0,181.511,8.017Z",
    transform: "translate(-181.024 -6.464)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.338 3.595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.788,39.957a.635.635,0,0,1-.462-1.07l1.25-1.331a.24.24,0,0,1,.35.328l-1.25,1.331a.155.155,0,0,0,.219.219l1.387-1.3a.24.24,0,1,1,.328.35l-1.387,1.3A.633.633,0,0,1,152.788,39.957Z",
    transform: "translate(-152.153 -37.48)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.011 2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.193,23.56a.391.391,0,0,1-.279-.115l-.677-.677a.24.24,0,1,1,.339-.339l.616.616.458-.458-.6-.6a.24.24,0,1,1,.339-.339l.663.663a.394.394,0,0,1,0,.557l-.579.579A.391.391,0,0,1,160.193,23.56Zm.519-.912h0Z",
    transform: "translate(-159.167 -21.575)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.478 0.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.928,9.147l-.026,0c-1.22-.136-1.795-.892-1.708-2.249a.455.455,0,0,1,.216-.36.479.479,0,0,1,.434-.035,1.378,1.378,0,0,0,.525.043,1.319,1.319,0,0,1,1.048.28,1.965,1.965,0,0,1,.548,1.285.24.24,0,0,1-.07.17l-.8.8A.24.24,0,0,1,144.928,9.147Zm-1.257-2.2c-.043.711.061,1.531,1.171,1.705l.635-.636a1.485,1.485,0,0,0-.4-.854c-.157-.157-.406-.149-.694-.14A1.759,1.759,0,0,1,143.671,6.948Z",
    transform: "translate(-143.185 -6.465)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.87 2.925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.646,33.636a.632.632,0,0,1-.434-.173L168.2,31.574a.24.24,0,1,1,.328-.35l2.011,1.889a.155.155,0,0,0,.219-.219l-1.88-2a.24.24,0,0,1,.35-.328l1.88,2a.635.635,0,0,1-.462,1.07Z",
    transform: "translate(-168.125 -30.489)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.646 3.453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,36.849a1.064,1.064,0,0,1-.854-.835c0-.019-.038-.019-.038,0a1.064,1.064,0,0,1-.854.835c-.019,0-.019.029,0,.038a1.064,1.064,0,0,1,.854.835c0,.019.038.019.038,0a1.064,1.064,0,0,1,.854-.835C21.621,36.878,21.621,36.849,21.6,36.849Z",
    transform: "translate(-19.842 -36)",
    fill: "#f5c84c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.829 7.564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.361,79.446a.747.747,0,0,1-.6-.586c0-.013-.027-.013-.027,0a.747.747,0,0,1-.6.586c-.013,0-.013.02,0,.027a.747.747,0,0,1,.6.586c0,.013.027.013.027,0a.747.747,0,0,1,.6-.586C179.375,79.466,179.375,79.446,179.361,79.446Z",
    transform: "translate(-178.126 -78.85)",
    fill: "#70d6f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.15 15.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.254,165.377h-.221v-.221a.309.309,0,0,0-.307-.307.3.3,0,0,0-.307.307v.221H192.2a.309.309,0,0,0-.307.307.3.3,0,0,0,.307.307h.221v.221a.309.309,0,0,0,.307.307.3.3,0,0,0,.307-.307v-.221h.221a.309.309,0,0,0,.307-.307A.3.3,0,0,0,193.254,165.377Z",
    transform: "translate(-191.892 -164.849)",
    fill: "#87d147"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.368 6.508)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.326,
    cy: 0.326,
    r: 0.326,
    fill: "#fc657e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.867 14.086)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.326,
    cy: 0.326,
    r: 0.326,
    fill: "#f5c84c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.077 12.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.139,131.992a1.21,1.21,0,0,1-.925-.4.24.24,0,1,1,.368-.308.786.786,0,0,0,1.115,0,.24.24,0,1,1,.367.308A1.21,1.21,0,0,1,119.139,131.992Z",
    transform: "translate(-118.158 -131.195)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.653 11.028)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.349,
    cy: 0.349,
    r: 0.349
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.691 11.028)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.349,
    cy: 0.349,
    r: 0.349
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/Step2.dbcf50f69f2b2ac8ad14429a60e668ca.svg";
export { ForwardRef as ReactComponent };